import { Admin, Resource } from 'react-admin';
import { Book, People } from '@material-ui/icons';
import { UserList, UserShow, UserCreate, UserEdit } from "./users";
import PocketBase from 'pocketbase';
import pocketBaseDataProvider from './pocketBaseDataProvider'; // der Adapter aus meiner vorherigen Antwort
import Dashboard from './Dashboard';
import { WikiCreate, WikiEdit, WikiList, WikiShow } from './wiki';
import { i18nProvider } from "./i18n";

const PB_URL =
  (typeof process !== 'undefined' && process.env && (process.env.REACT_APP_PB_URL || process.env.PB_URL)) ||
  'https://pbase.dfiav.de';

const pb = new PocketBase(PB_URL);
pb.autoCancellation(false);

export const dataProvider = pocketBaseDataProvider(pb, { context: '', imagekey: 'images', filekey: 'files' });

export const authProvider = (() => {
  const authWithPassword = (identity, password) =>
    pb.collection('users').authWithPassword(identity, password);

  return {
    login: async ({ username, email, password }) => {
      const identity = email || username;
      if (!identity || !password) throw new Error('Missing credentials');
      await authWithPassword(identity, password);
    },
    logout: async () => { pb.authStore.clear(); },
    checkError: ({ status }) => (status === 401 || status === 403 ? (pb.authStore.clear(), Promise.reject()) : Promise.resolve()),
    checkAuth: async () => (pb.authStore.isValid ? Promise.resolve() : Promise.reject()),
    getPermissions: async () => pb.authStore.model?.role || 'user',
    getIdentity: async () => {
      const user = pb.authStore.model;
      if (!user) throw new Error('No session');
      return {
        id: user.id,
        fullName: user.name || user.username || user.email,
        avatar: user.avatar ? pb.files.getUrl(user, user.avatar) : undefined,
      };
    },
  };
})();

const App = () => <Admin
  dataProvider={dataProvider}
  authProvider={authProvider}
  i18nProvider={i18nProvider}
  dashboard={Dashboard}
  disableTelemetry
>
  <Resource name="users" list={UserList} show={UserShow} create={UserCreate} edit={UserEdit} icon={People} options={{ label: 'Benutzer' }} />
  <Resource name="wiki" list={WikiList} show={WikiShow} create={WikiCreate} edit={WikiEdit} icon={Book} options={{ label: 'Wiki' }} />
  {/* <Resource name="deletedUsers" list={DeletedUserList} show={UserShow} create={UserCreate} edit={UserEdit} icon={DeleteIcon} options={{ label: 'Gelöscht' }} /> */}
  {/* <Resource name="currentAppVersionWeb" list={VersionsList}/> */}
</Admin>;

export default App;
